
export const UNCANCEL_ORDER= 'UNCANCEL_ORDER'
export const UNCANCEL_ORDER_SUCCESS= 'UNCANCEL_ORDER_SUCCESS'
export const UNCANCEL_ORDER_ERROR='UNCANCEL_ORDER_ERROR'


export const UnCancelOrder= (data) => ({
    type: UNCANCEL_ORDER,
    payload: data
});